import { createAction } from 'typesafe-actions';

export const contentModalOpened = createAction('@CONTENT_MODAL/OPENED');
export const contentModalClosed = createAction('@CONTENT_MODAL/CLOSED');
